exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/bundles/videojs/layout/nls/autoplayMenuSection.js-WebpackMultiOutput";